import CardTitleContainer from "@/src/mui-custom/card/card-title-container/card-title-container";
import CardTitleText from "@/src/mui-custom/card/card-title-text/card-title-text";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import CardTitleDivider from "@/src/mui-custom/card/card-title-divider/card-title-divider";
import CardBodyBox from "@/src/mui-custom/card/card-body-box/card-body-box";
import CardBox from "@/src/mui-custom/card/card-box/card-box";
import MetricsItemBox
    from "@/src/components/journal-site/home/journal-metrics/mui-custom/metrics-item-box/metrics-item-box";
import {faChartSimple,} from '@fortawesome/pro-duotone-svg-icons';
import NextLink from "next/link";
import Link from "@mui/material/Link";
import CardTitleBox from "@/src/mui-custom/card/card-title-box/card-title-box";
import CustomBox from "@/src/mui-custom/custom-box/custom-box";
import MetricsItem from "@/src/components/journal-site/home/journal-metrics/mui-custom/metrics-item/metrics-item";
import MetricsItemText
    from "@/src/components/journal-site/home/journal-metrics/mui-custom/metrics-item-text/metrics-item-text";
import DescriptionMetrics
    from "@/src/components/journal-site/home/journal-metrics/mui-custom/description-metrics/description-metrics";
import Journal from "@/src/_types/journal";

const JournalMetrics = ({journal}: { journal: Journal }) => {
    const data = {
        metric_title: journal.options?.template_configs?.journal_metrics?.metrics?.label,
        metric_caption: journal.options?.template_configs?.journal_metrics?.metrics?.caption,
        journalIFScore: journal.meta_data?.if_score,
        journalIFScoreLink: journal.meta_data?.if_score_link,
        journalCitationScoreLink: journal.meta_data?.citation_score_link,
        journalCitationScore: journal.meta_data?.citation_score,
        journalPubMedLink: journal.meta_data?.pmc_link,
        journalESCI: journal.meta_data?.esci,
        journalESCILink: journal.meta_data?.esci_link,
        journal_time_to_first_decision: journal.meta_data?.time_to_first_decision,
        journal_time_to_first_decision_link: journal.meta_data?.time_to_first_decision_link,
        journal_review_time: journal.meta_data?.review_time,
        journal_review_time_link: journal.meta_data?.review_time_link,
        journal_publication_time: journal.meta_data?.publication_time,
        journal_publication_time_link: journal.meta_data?.publication_time_link,
        journal_acceptance_rate: journal.meta_data?.acceptance_rate,
        journal_acceptance_rate_link: journal.meta_data?.acceptance_rate_link,
        journal_open_peer_review: journal.meta_data?.open_peer_review,
        journal_open_peer_review_link: journal.meta_data?.open_peer_review_link,
        journal_acceptance_fee: journal.meta_data?.acceptance_fee,
        journal_acceptance_fee_link: journal.meta_data?.acceptance_fee_link,
    }

    const {
        journalIFScore,
        journalIFScoreLink,
        journalCitationScore,
        journalCitationScoreLink,
        journalPubMedLink,
        journalESCILink,
        journal_time_to_first_decision,
        journal_time_to_first_decision_link,
        journal_review_time,
        journal_review_time_link,
        journal_publication_time,
        journal_publication_time_link,
        journal_acceptance_rate,
        journal_acceptance_rate_link,
        journal_open_peer_review,
        journal_open_peer_review_link,
        journal_acceptance_fee,
        journal_acceptance_fee_link,
    } = data;

    return (
        <CardBox sx={{
            paddingY: '1rem',
            paddingX: '.5rem',
            width: '100%',
        }}>
            <CardTitleContainer>
                <CardTitleBox>
                    <FontAwesomeIcon icon={faChartSimple} className={'icon'}/>
                    <CardTitleText variant={"h2"}>
                        {data.metric_title}
                    </CardTitleText>
                </CardTitleBox>
                <CardTitleDivider/>
            </CardTitleContainer>
            <CardBodyBox
                sx={{
                    width: '85%',
                    margin: '0 auto',
                }}>

                <DescriptionMetrics>
                    {data.metric_caption}
                </DescriptionMetrics>

                <CustomBox
                    sx={{
                        paddingX: '0',
                        marginTop: '1rem',
                        gap: '0.25rem',
                        flexDirection: 'column',
                        display: 'flex',
                    }}
                >
                    {(journalIFScore || journalCitationScore || journalPubMedLink || journalESCILink) && (
                        <>
                            {journalESCILink && !journalIFScore && (
                                <MetricsItemBox>
                                    <MetricsItem>
                                        <i className={`icon ${journal.options?.template_configs?.journal_metrics?.if_score?.icon}`}></i>
                                        <MetricsItemText component={'span'} sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            marginRight: '.5rem',
                                            lineHeight: '1.25'
                                        }}>
                                            <MetricsItemText component={'span'}>
                                                {journal.options?.template_configs?.journal_metrics?.if_score?.label}
                                            </MetricsItemText>
                                        </MetricsItemText>
                                    </MetricsItem>

                                    <MetricsItem>
                                        {journalESCILink ? (
                                            <Link
                                                component={NextLink} href={journalESCILink} underline="none">
                                                <MetricsItemText component={'span'}>
                                                    WoS | ESCI
                                                </MetricsItemText>
                                            </Link>
                                        ) : (
                                            <MetricsItemText component={'span'}>
                                                WoS | ESCI
                                            </MetricsItemText>
                                        )}
                                    </MetricsItem>
                                </MetricsItemBox>
                            )}

                            {journalIFScore && (
                                <MetricsItemBox>
                                    <MetricsItem>
                                        <i className={`icon ${journal.options?.template_configs?.journal_metrics?.if_score?.icon}`}></i>
                                        <MetricsItemText component={'span'} sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            marginRight: '.5rem',
                                            lineHeight: '1.25',
                                        }}>
                                            <MetricsItemText component={'span'}>
                                                {journal.options?.template_configs?.journal_metrics?.if_score?.label}
                                            </MetricsItemText>
                                        </MetricsItemText>
                                    </MetricsItem>

                                    <MetricsItem>
                                        {journalIFScoreLink ? (
                                            <Link
                                                component={NextLink} href={journalIFScoreLink} underline="none">
                                                <MetricsItemText component={'span'}>
                                                    {journalIFScore}
                                                </MetricsItemText>
                                            </Link>
                                        ) : (
                                            <MetricsItemText component={'span'}>
                                                {journalIFScore}
                                            </MetricsItemText>
                                        )}
                                    </MetricsItem>
                                </MetricsItemBox>
                            )}

                            {journalCitationScore && (
                                <MetricsItemBox>
                                    <MetricsItem>
                                        <i className={`icon ${journal.options?.template_configs?.journal_metrics?.citation_score?.icon}`}></i>
                                        <MetricsItemText component={'span'} sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            marginRight: '.5rem',
                                            lineHeight: '1.25'
                                        }}>
                                            <MetricsItemText component={'span'}>
                                                {journal.options?.template_configs?.journal_metrics?.citation_score?.label}
                                            </MetricsItemText>
                                        </MetricsItemText>
                                    </MetricsItem>

                                    <MetricsItem>
                                        {journalCitationScoreLink ? (
                                            <Link
                                                component={NextLink} href={journalCitationScoreLink} underline="none">
                                                <MetricsItemText component={'span'}>
                                                    {journalCitationScore}
                                                </MetricsItemText>
                                            </Link>
                                        ) : (
                                            <MetricsItemText component={'span'}>
                                                {journalCitationScore && ` ${journalCitationScore}`}
                                            </MetricsItemText>
                                        )}
                                    </MetricsItem>
                                </MetricsItemBox>
                            )}

                            {journalPubMedLink && (
                                <MetricsItemBox>
                                    <MetricsItem>
                                        {journalPubMedLink ? (
                                            <Link
                                                component={NextLink} href={journalPubMedLink} underline="none">
                                                <MetricsItemText component={'span'}>
                                                    <i className={`icon ${journal.options?.template_configs?.journal_metrics?.pmc?.icon}`}></i>
                                                    {journal.options?.template_configs?.journal_metrics?.pmc?.label}
                                                </MetricsItemText>
                                            </Link>
                                        ) : (
                                            <MetricsItemText component={'span'}>
                                                <i className={`icon ${journal.options?.template_configs?.journal_metrics?.pmc?.icon}`}></i>
                                                {journal.options?.template_configs?.journal_metrics?.pmc?.label}
                                            </MetricsItemText>
                                        )}
                                    </MetricsItem>
                                </MetricsItemBox>
                            )}
                        </>
                    )}

                    {journal_time_to_first_decision && (
                        <MetricsItemBox>
                            <MetricsItem>
                                {journal_time_to_first_decision_link ? (
                                    <Link
                                        component={NextLink} href={journal_time_to_first_decision_link}
                                        underline="none">
                                        <MetricsItemText component={'span'}>
                                            <i className={`icon ${journal.options?.template_configs?.journal_metrics?.time_to_first_decision?.icon}`}></i>
                                            {journal.options?.template_configs?.journal_metrics?.time_to_first_decision?.label}
                                        </MetricsItemText>
                                    </Link>
                                ) : (
                                    <MetricsItemText component={'span'}>
                                        <i className={`icon ${journal.options?.template_configs?.journal_metrics?.time_to_first_decision?.icon}`}></i>
                                        {journal.options?.template_configs?.journal_metrics?.time_to_first_decision?.label}
                                    </MetricsItemText>
                                )}
                            </MetricsItem>

                            <MetricsItem>
                                {journal_time_to_first_decision_link ? (
                                    <Link
                                        component={NextLink} href={journal_time_to_first_decision_link}
                                        underline="none">
                                        <MetricsItemText component={'span'}>
                                            {journal_time_to_first_decision && ` ${journal_time_to_first_decision}`}
                                        </MetricsItemText>
                                    </Link>
                                ) : (
                                    <MetricsItemText component={'span'}>
                                        {journal_time_to_first_decision && ` ${journal_time_to_first_decision}`}
                                    </MetricsItemText>
                                )}
                            </MetricsItem>
                        </MetricsItemBox>
                    )}

                    {journal_review_time && (
                        <MetricsItemBox>
                            <MetricsItem>
                                {journal_review_time_link ? (
                                    <Link
                                        component={NextLink} href={journal_review_time_link} underline="none">
                                        <MetricsItemText component={'span'}>
                                            <i className={`icon ${journal.options?.template_configs?.journal_metrics?.review_time?.icon}`}></i>
                                            {journal.options?.template_configs?.journal_metrics?.review_time?.label}
                                        </MetricsItemText>
                                    </Link>
                                ) : (
                                    <MetricsItemText component={'span'}>
                                        <i className={`icon ${journal.options?.template_configs?.journal_metrics?.review_time?.icon}`}></i>
                                        {journal.options?.template_configs?.journal_metrics?.review_time?.label}
                                    </MetricsItemText>
                                )}
                            </MetricsItem>

                            <MetricsItem>
                                {journal_review_time_link ? (
                                    <Link
                                        component={NextLink} href={journal_review_time_link} underline="none">
                                        <MetricsItemText component={'span'}>
                                            {journal_review_time && ` ${journal_review_time}`}
                                        </MetricsItemText>
                                    </Link>
                                ) : (
                                    <MetricsItemText component={'span'}>
                                        {journal_review_time && ` ${journal_review_time}`}
                                    </MetricsItemText>
                                )}
                            </MetricsItem>
                        </MetricsItemBox>
                    )}

                    {journal_publication_time && (
                        <MetricsItemBox>
                            <MetricsItem>
                                {journal_publication_time_link ? (
                                    <Link
                                        component={NextLink} href={journal_publication_time_link} underline="none">
                                        <MetricsItemText component={'span'}>
                                            <i className={`icon ${journal.options?.template_configs?.journal_metrics?.publication_time?.icon}`}></i>
                                            {journal.options?.template_configs?.journal_metrics?.publication_time?.label}
                                        </MetricsItemText>
                                    </Link>
                                ) : (
                                    <MetricsItemText component={'span'}>
                                        <i className={`icon ${journal.options?.template_configs?.journal_metrics?.publication_time?.icon}`}></i>
                                        {journal.options?.template_configs?.journal_metrics?.publication_time?.label}
                                    </MetricsItemText>
                                )}
                            </MetricsItem>

                            <MetricsItem>
                                {journal_publication_time_link ? (
                                    <Link
                                        component={NextLink} href={journal_publication_time_link} underline="none">
                                        <MetricsItemText component={'span'}>
                                            {journal_publication_time && ` ${journal_publication_time}`}
                                        </MetricsItemText>
                                    </Link>
                                ) : (
                                    <MetricsItemText component={'span'}>
                                        {journal_publication_time && ` ${journal_publication_time}`}
                                    </MetricsItemText>
                                )}
                            </MetricsItem>
                        </MetricsItemBox>
                    )}

                    {journal_acceptance_rate && (
                        <MetricsItemBox>
                            <MetricsItem>
                                {journal_acceptance_rate_link ? (
                                    <Link
                                        component={NextLink} href={journal_acceptance_rate_link} underline="none">
                                        <MetricsItemText component={'span'}>
                                            <i className={`icon ${journal.options?.template_configs?.journal_metrics?.acceptance_rate?.icon}`}></i>
                                            {journal.options?.template_configs?.journal_metrics?.acceptance_rate?.label}
                                        </MetricsItemText>
                                    </Link>
                                ) : (
                                    <MetricsItemText component={'span'}>
                                        <i className={`icon ${journal.options?.template_configs?.journal_metrics?.acceptance_rate?.icon}`}></i>
                                        {journal.options?.template_configs?.journal_metrics?.acceptance_rate?.label}
                                    </MetricsItemText>
                                )}
                            </MetricsItem>

                            <MetricsItem>
                                {journal_acceptance_rate_link ? (
                                    <Link
                                        component={NextLink} href={journal_acceptance_rate_link} underline="none">
                                        <MetricsItemText component={'span'}>
                                            {journal_acceptance_rate && ` ${journal_acceptance_rate}`}
                                        </MetricsItemText>
                                    </Link>
                                ) : (
                                    <MetricsItemText component={'span'}>
                                        {journal_acceptance_rate && ` ${journal_acceptance_rate}`}
                                    </MetricsItemText>
                                )}
                            </MetricsItem>
                        </MetricsItemBox>
                    )}

                    {journal_open_peer_review && (
                        <MetricsItemBox>
                            <MetricsItem>
                                {journal_open_peer_review_link ? (
                                    <Link
                                        component={NextLink} href={journal_open_peer_review_link} underline="none">
                                        <MetricsItemText component={'span'}>
                                            <i className={`icon ${journal.options?.template_configs?.journal_metrics?.open_peer_review?.icon}`}></i>
                                            {journal.options?.template_configs?.journal_metrics?.open_peer_review?.label}
                                        </MetricsItemText>
                                    </Link>
                                ) : (
                                    <MetricsItemText component={'span'}>
                                        <i className={`icon ${journal.options?.template_configs?.journal_metrics?.open_peer_review?.icon}`}></i>
                                        {journal.options?.template_configs?.journal_metrics?.open_peer_review?.label}
                                    </MetricsItemText>
                                )}
                            </MetricsItem>

                            <MetricsItem>
                                {journal_open_peer_review_link ? (
                                    <Link
                                        component={NextLink} href={journal_open_peer_review_link} underline="none">
                                        <MetricsItemText component={'span'}>
                                            {journal_open_peer_review && ` ${journal_open_peer_review}`}
                                        </MetricsItemText>
                                    </Link>
                                ) : (
                                    <MetricsItemText component={'span'}>
                                        {journal_open_peer_review && ` ${journal_open_peer_review}`}
                                    </MetricsItemText>
                                )}
                            </MetricsItem>
                        </MetricsItemBox>
                    )}

                    {journal_acceptance_fee && (
                        <MetricsItemBox>
                            <MetricsItem>
                                {journal_acceptance_fee_link ? (
                                    <Link
                                        component={NextLink} href={journal_acceptance_fee_link} underline="none">
                                        <MetricsItemText component={'span'}>
                                            <i style={{marginRight: '0.25rem'}}
                                               className={`fa-duotone ${journal.options?.template_configs?.journal_metrics?.acceptance_fee?.icon}`}></i>
                                            {journal.options?.template_configs?.journal_metrics?.acceptance_fee?.label}
                                        </MetricsItemText>
                                    </Link>
                                ) : (
                                    <MetricsItemText component={'span'}>
                                        <i style={{marginRight: '0.25rem'}}
                                           className={`fa-duotone ${journal.options?.template_configs?.journal_metrics?.acceptance_fee?.icon}`}></i>
                                        {journal.options?.template_configs?.journal_metrics?.acceptance_fee?.label}
                                    </MetricsItemText>
                                )}
                            </MetricsItem>

                            <MetricsItem>
                                {journal_acceptance_fee_link ? (
                                    <Link
                                        component={NextLink} href={journal_acceptance_fee_link} underline="none">
                                        <MetricsItemText component={'span'}>
                                            {journal_acceptance_fee && ` ${journal_acceptance_fee}`}
                                        </MetricsItemText>
                                    </Link>
                                ) : (
                                    <MetricsItemText component={'span'}>
                                        {journal_acceptance_fee && ` ${journal_acceptance_fee}`}
                                    </MetricsItemText>
                                )}
                            </MetricsItem>
                        </MetricsItemBox>
                    )}
                </CustomBox>
            </CardBodyBox>
        </CardBox>
    )
}
export default JournalMetrics;
